import CloseIcon from "@mui/icons-material/Close";
import CategoryCard from "./CategoryCard/index.js";
import style from "./style.module.scss";
import { useTranslation } from "react-i18next";

const SubMenu = ({ categories, onClick, onMouseLeave }) => {
  const { t } = useTranslation();

  return (
    <div className={style.subMenu} onMouseLeave={onMouseLeave}>
      <div className={style.container}>
        {Object.values(categories).map((category) => (
          <CategoryCard
            key={category.cat_ID}
            category={category}
            role="menuitem"
          />
        ))}
      </div>

      <button
        className={style.closeBtn}
        onClick={onClick}
        aria-label={t("Close submenu")}
        tabIndex={0}
        role="menuitem"
      >
        <CloseIcon />
      </button>
    </div>
  );
};

export default SubMenu;
